import { Route } from "react-router-dom";
import { AuditSessionPageV2 } from "../pages/audit/AuditSessionPageV2";
import { AuditDocumentsPageV2 } from "../pages/audit/auditDocuments/AuditDocumentsPageV2";
import { AuditWorkpaperViewPageV2WithProvider } from "../pages/audit/auditWorkPaperView/AuditWorkPaperViewV2WithProvider";
import { AuditWorkPaperV2Page } from "../pages/audit/auditWorkPaperV2Page/AuditWorkPaperV2Page";

// Sibling of AuditRoutesV2 for work step sessions: same pages, same
// `:controlSessionId` param name (the shared pages/context read it by that
// name) — only the shell route (`/audit/work-step-sessions/session`, mounted
// with `<AuditProvider sessionKind="work_step">`) differs.
export const WorkStepAuditRoutesV2 = [
  <Route
    key="work-step-audit-test"
    path=":controlSessionId"
    element={<AuditSessionPageV2 />}
  />,

  <Route
    key="work-step-audit-documents"
    path=":controlSessionId/documents"
    element={<AuditDocumentsPageV2 />}
  />,
  <Route
    key="work-step-audit-workpaper-view"
    path=":controlSessionId/workpaper-view"
    element={<AuditWorkpaperViewPageV2WithProvider />}
  />,
  <Route
    key="work-step-audit-workpaper-v2"
    path=":controlSessionId/workpaper-v2"
    element={<AuditWorkPaperV2Page />}
  />,
];
